import { useState } from 'react';

import { Grid } from '@mui/material';

import { StoreAutoComplete } from 'components/autocompletes';
import { DatePickerMonthYear } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function FormFilterExtratoFPP() {
    const [filterLoja, setFilterLoja] = useState<FilterValuesProps>({
        property: 'cdLoja',
        operator: 'eq',
        value: null,
        idProperty: 'cdLoja',
        required: 'Loja é obrigatória',
    });

    const [filterDtFiltro, setFilterDtFiltro] = useState<FilterValuesProps>({
        property: 'dtFiltro',
        operator: 'eq',
        value: null,
        required: 'Selecione o mês/ano para prosseguir.',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterLoja, setter: setFilterLoja },
                { value: filterDtFiltro, setter: setFilterDtFiltro },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <StoreAutoComplete
                    value={filterLoja.value}
                    onChange={(e, value) => setFilterLoja((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <DatePickerMonthYear
                    minDate={new Date('2010-01-01')}
                    maxDate={new Date()}
                    value={filterDtFiltro.value}
                    onChange={(value) => setFilterDtFiltro((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
        </Filter>
    );
}
